import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { SubjectService } from "@app/services/subject.service";
import { MultimediaService } from "@app/services/multimedia.service";
import { HelperService } from "@services/helper.service";
import { ModalService } from "@services/modal.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-transactions",
  templateUrl: "./transactions.component.html",
  styleUrls: ["./transactions.component.scss"],
})
export class TransactionsComponent implements OnInit {
  @ViewChild("content") content: any;

  public displayStyle = "none";
  public urlPopup: string;
  public primaryImage: string;
  public primaryImageData: string;
  public responsiveImage: string;
  public responsiveImageData: string;
  public currentImage: string;

  responseData: any;

  constructor(
    public helper: HelperService,
    public toastr: ToastrService,
    private modal: ModalService,
    public subject: SubjectService,
    private multimediaService: MultimediaService
  ) {}

  validatePopUp() {
    this.subject.headerCollapse(true);
    let popUpChristhmast = localStorage.getItem("popUpChristhmas");
    if (popUpChristhmast && this.responseData && this.primaryImageData && this.responsiveImageData) {
      this.displayStyle = "block";
    }

    localStorage.removeItem("popUpChristhmas");
  }

  ngOnInit() {
    this.multimediaService.getPopUp().subscribe({
      next: (response: Response) => {
        const { attributes: attr } = response["data"][0];
        const { urlApi } = this.multimediaService;
        const { url: primaryUrl } = attr.imgPopup1.data.attributes;    
        const { url: responsiveUrl } = attr.imgPopupMobile1.data.attributes;
     
        this.urlPopup = attr.urlPopup1;
        this.responseData = attr.activePopup1;
        this.primaryImageData = attr.imgPopup1.data;
        this.primaryImage = `${urlApi}${primaryUrl}`;
        this.responsiveImageData = attr.imgPopupMobile1.data;
        this.responsiveImage = `${urlApi}${responsiveUrl}`;

        this.updateBackgroundImage(window.innerWidth);
        this.validatePopUp();
      },
      error: () => {
        // Manejo de errores
      },
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateBackgroundImage((<Window>event.target).innerWidth);
  }
 
  updateBackgroundImage(width: number) {
    this.currentImage = width < 768 ? this.responsiveImage : this.primaryImage;
  }

  redirectToUrl() {
    if(this.urlPopup) {
      window.open(this.urlPopup, '_newtab');
    } else {
      console.warn("La variable urlPopup1 está vacía.")
    }
  }

  closePopup() {
    this.displayStyle = "none";
  }

  ngOnDestroy() {
    this.subject.headerCollapse(false);
  }

  transaction() {
    this.modal.show("transactionSuccess");
  }
}
